<template>
  <v-ons-page>
    <v-ons-toolbar class="home-toolbar" style="color: black;">
      <div class="left">
        <v-ons-button modifier="quiet" style="margin: 6px 0" @click="goBack()">＜戻る</v-ons-button>
      </div>
      <div class="center" style="text-align: center;">{{ msg }}</div>
      <div class="right"></div>
    </v-ons-toolbar>

    <v-ons-list>
      <div v-if="inData.type === ''">
        <v-ons-list-header>投稿タイプを選択してください。</v-ons-list-header>
        <v-ons-list-item>
          <div class="center">
            <v-ons-select :disabled="disable" v-model="inData.type">
              <option v-for="(type, index) in postTypes" :value="type.type" :key="index">
                {{ type.name }}
              </option>
            </v-ons-select>
          </div>
        </v-ons-list-item>
      </div>
      <div v-else>
        <v-ons-list-header>投稿タイプ</v-ons-list-header>
        <v-ons-list-item>
          <div class="center">
            {{ inData.type }}
          </div>
        </v-ons-list-item>
      </div>

      <div v-if="inData.type === 'email'">
        <v-ons-list-header>送信者名</v-ons-list-header>
        <v-ons-list-item>
          <div class="center">
            <v-ons-input :disabled="disable" placeholder="メール送信者の名前" style="width: 100%;" float v-model="inData.userName"></v-ons-input>
          </div>
        </v-ons-list-item>

        <v-ons-list-header>タイトル</v-ons-list-header>
        <v-ons-list-item>
          <div class="center">
            <v-ons-input :disabled="disable" placeholder="〇〇のお知らせ" style="width: 100%;" float v-model="inData.title"></v-ons-input>
          </div>
        </v-ons-list-item>

        <v-ons-list-header>宛先アドレス（To）</v-ons-list-header>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button :disabled="disable" @click="dialogAddAddress = !dialogAddAddress" modifier="quiet"><v-ons-icon icon="fa-plus">　Toアドレスの追加</v-ons-icon></v-ons-button>
          </div>
        </v-ons-list-item>
        <div v-for="(address, index) in inData.toAddress" :key="index">
          <v-ons-list-item>
            <div class="center">
              <span class="list-item__title">{{address.name}}</span>
              <span class="list-item__subtitle">{{address.address}}</span>
            </div>
            <div class="right">
              <v-ons-button :disabled="disable" modifier="quiet" @click="delAddress(index)"><v-ons-icon icon="fa-times-circle"></v-ons-icon></v-ons-button>
            </div>
          </v-ons-list-item>
        </div>
        <v-ons-list-header>宛先アドレス（BCC）</v-ons-list-header>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button :disabled="disable" @click="dialogAddBcc = !dialogAddBcc" modifier="quiet"><v-ons-icon icon="fa-plus">　BCCアドレスの追加</v-ons-icon></v-ons-button>
          </div>
        </v-ons-list-item>
        <div v-for="(address, index) in inData.bccAddress" :key="'bcc' + index">
          <v-ons-list-item>
            <div class="center">
              <span class="list-item__title">{{address.name}}</span>
              <span class="list-item__subtitle">{{address.address}}</span>
            </div>
            <div class="right">
              <v-ons-button :disabled="disable" modifier="quiet" @click="delBcc(index)"><v-ons-icon icon="fa-times-circle"></v-ons-icon></v-ons-button>
            </div>
          </v-ons-list-item>
        </div>

        <v-ons-list-header>内容</v-ons-list-header>
        <v-ons-list-item>
          <div class="center">
            <vue-editor :disabled="disable" v-model="inData.content" :editorToolbar="customToolbar"></vue-editor>
          </div>
        </v-ons-list-item>
        <v-ons-list-item>
          <div class="center">
            <span style="color: grey; font-size: 0.8em;">半角スペースは正しく表示されません。<br>全角スペースをご使用ください。</span>
          </div>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <span style="font-size: 0.8em;">
              <span v-if="inData.content.length > emailMaxLen" style="color: red">
                {{inData.content | stringLengthCheck(emailMaxLen)}}
              </span>
              <span v-else style="color: gray">
                {{inData.content | stringLengthCheck(emailMaxLen)}}
              </span>
            </span>
          </div>
        </v-ons-list-item>
        <!-- <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button modifier="large" :disabled="sendLoading || disable" v-on:click="sendEmailDirect()">
              <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon>　</span>メール送信
            </v-ons-button>
          </div>
        </v-ons-list-item> -->

      </div>

      <div v-if="inData.type === 'twitter' && isTwitter">
        <v-ons-list-header>Tweet か DMを選択してください</v-ons-list-header>
        <v-ons-list-item modifier="nodivider">
          <label class="left">
            <v-ons-radio input-id="radio-tweet" value="tweet" v-model="inData.postType"></v-ons-radio>
          </label>
          <label for="radio-tweet" class="center">
            Tweet（通常のつぶやき)
          </label>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <label class="left">
            <v-ons-radio input-id="radio-dm" value="dm" v-model="inData.postType"></v-ons-radio>
          </label>
          <label for="radio-dm" class="center">
            DM（ダイレクトメッセージ）
          </label>
        </v-ons-list-item>

        <div v-if="(inData.postType === 'dm') && (!isScreenNameDone)">
          <v-ons-list-header>DMの送信先を検索</v-ons-list-header>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <v-ons-input placeholder="スクリーンネームで検索" float v-model="targetScreenName"></v-ons-input>
            </div>
            <div class="right">
              <v-ons-button @click="searchScreenName(targetScreenName)">
                <span v-show="!sendLoading"><v-ons-icon icon="fa-search"></v-ons-icon></span>
                <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon></span>
              </v-ons-button>
            </div>
          </v-ons-list-item>
          <div v-show="screenNameSearchResult.name">
            <v-ons-list-item modifier="nodivider">
              <div class="left">
                <img :src="screenNameSearchResult.profile_image_url_https">
              </div>
              <div class="center">
                {{screenNameSearchResult.name}}@{{screenNameSearchResult.screen_name}}
              </div>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
              <div class="center">
                <span v-show="screenNameSearchResult.following">
                  <v-ons-button modifier="large" @click="setDMparams(screenNameSearchResult)">DM送信先を確定</v-ons-button>
                </span>
                <span v-show="screenNameSearchResult.following === false" style="color: red">
                  相手があなたをフォローしていません！<br>
                  フォローされていない相手にDMを送ることはできません。
                </span>
              </div>
            </v-ons-list-item>
          </div>
        </div>
        <div v-else-if="isScreenNameDone">
          <v-ons-list-header>DMの送信先</v-ons-list-header>
          <v-ons-list-item modifier="nodivider">
            <div class="left">
              <img :src="screenNameSearchResult.profile_image_url_https">
            </div>
            <div class="center">
              {{screenNameSearchResult.name}}@{{screenNameSearchResult.screen_name}}
            </div>
          </v-ons-list-item>
        </div>

        <v-ons-list-header>投稿内容</v-ons-list-header>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <textarea class="textarea" style="font-size: 0.9em" cols="40" rows="10" v-model="inData.content" placeholder="内容を入力してください。"></textarea>
          </div>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <span style="font-size: 0.8em;">
              <span v-if="(inData.postType === 'tweet') && (inData.content.length > twitterMaxLen)" style="color: red">
                {{inData.content | stringLengthCheck(twitterMaxLen)}}
              </span>
              <span v-else-if="(inData.postType === 'tweet') && (inData.content.length < twitterMaxLen)" style="color: gray">
                {{inData.content | stringLengthCheck(twitterMaxLen)}}
              </span>
              <span v-else-if="(inData.postType === 'dm') && (inData.content.length > twitterDMmaxLen)" style="color: red">
                {{inData.content | stringLengthCheck(twitterDMmaxLen)}}
              </span>
              <span v-else-if="(inData.postType === 'dm') && (inData.content.length < twitterDMmaxLen)" style="color: gray">
                {{inData.content | stringLengthCheck(twitterDMmaxLen)}}
              </span>
            </span>
          </div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button modifier="large" :disabled="sendLoading || disable" v-on:click="testTweet()">
              <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon>　</span>今すぐ投稿（アカウント確認用）
            </v-ons-button>
          </div>
        </v-ons-list-item>
        <!-- <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button modifier="large" :disabled="sendLoading || disable" v-on:click="testDM()">
              <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon>　</span>DMのテスト
            </v-ons-button>
          </div>
        </v-ons-list-item> -->

      </div>
      <div v-else-if="inData.type === 'twitter' && !isTwitter">
        <v-ons-list>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              Twitterアカウントが連携されていません！<br>
              Twitterのアカウント連携を行ってください。
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <v-ons-button modifier="large" @click="goOauth()">アカウント連携へ</v-ons-button>
            </div>
          </v-ons-list-item>
        </v-ons-list>
      </div>

      <!-- <div v-if="inData.type === 'facebook' && isFacebook"> -->
      <!-- <div v-if="inData.type === 'facebook'">
        <v-ons-list-header>Feed か DMを選択してください</v-ons-list-header>
        <v-ons-list-item modifier="nodivider">
          <label class="left">
            <v-ons-radio input-id="radio-tweet" value="tweet" v-model="inData.postType"></v-ons-radio>
          </label>
          <label for="radio-tweet" class="center">
            Feed（通常のタイムライン投稿)
          </label>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <label class="left">
            <v-ons-radio input-id="radio-dm" value="dm" v-model="inData.postType"></v-ons-radio>
          </label>
          <label for="radio-dm" class="center">
            DM（ダイレクトメッセージ）
          </label>
        </v-ons-list-item>

        <div v-if="(inData.postType === 'dm') && (!isScreenNameDone)">
          <v-ons-list-header>DMの送信先を検索</v-ons-list-header>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <v-ons-input placeholder="スクリーンネームで検索" float v-model="targetScreenName"></v-ons-input>
            </div>
            <div class="right">
              <v-ons-button @click="searchScreenName(targetScreenName)">
                <span v-show="!sendLoading"><v-ons-icon icon="fa-search"></v-ons-icon></span>
                <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon></span>
              </v-ons-button>
            </div>
          </v-ons-list-item>
          <div v-show="screenNameSearchResult.name">
            <v-ons-list-item modifier="nodivider">
              <div class="left">
                <img :src="screenNameSearchResult.profile_image_url_https">
              </div>
              <div class="center">
                {{screenNameSearchResult.name}}@{{screenNameSearchResult.screen_name}}
              </div>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
              <div class="center">
                <span v-show="screenNameSearchResult.following">
                  <v-ons-button modifier="large" @click="setDMparams(screenNameSearchResult)">DM送信先を確定</v-ons-button>
                </span>
                <span v-show="screenNameSearchResult.following === false" style="color: red">
                  相手があなたをフォローしていません！<br>
                  フォローされていない相手にDMを送ることはできません。
                </span>
              </div>
            </v-ons-list-item>
          </div>
        </div>
        <div v-else-if="isScreenNameDone">
          <v-ons-list-header>DMの送信先</v-ons-list-header>
          <v-ons-list-item modifier="nodivider">
            <div class="left">
              <img :src="screenNameSearchResult.profile_image_url_https">
            </div>
            <div class="center">
              {{screenNameSearchResult.name}}@{{screenNameSearchResult.screen_name}}
            </div>
          </v-ons-list-item>
        </div>

        <v-ons-list-header>投稿内容</v-ons-list-header>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <textarea class="textarea" style="font-size: 0.9em" cols="40" rows="10" v-model="inData.content" placeholder="内容を入力してください。"></textarea>
          </div>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <span style="font-size: 0.8em;">
              <span v-if="(inData.postType === 'tweet') && (inData.content.length > twitterMaxLen)" style="color: red">
                {{inData.content | stringLengthCheck(twitterMaxLen)}}
              </span>
              <span v-else-if="(inData.postType === 'tweet') && (inData.content.length < twitterMaxLen)" style="color: gray">
                {{inData.content | stringLengthCheck(twitterMaxLen)}}
              </span>
              <span v-else-if="(inData.postType === 'dm') && (inData.content.length > twitterDMmaxLen)" style="color: red">
                {{inData.content | stringLengthCheck(twitterDMmaxLen)}}
              </span>
              <span v-else-if="(inData.postType === 'dm') && (inData.content.length < twitterDMmaxLen)" style="color: gray">
                {{inData.content | stringLengthCheck(twitterDMmaxLen)}}
              </span>
            </span>
          </div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button modifier="large" :disabled="sendLoading || disable" v-on:click="extendFacebookToken()">
              <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon>　</span>トークンの延長
            </v-ons-button>
          </div>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button modifier="large" :disabled="sendLoading || disable" v-on:click="testFacebook()">
              <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon>　</span>今すぐ投稿（アカウント確認用）
            </v-ons-button>
          </div>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button modifier="large" :disabled="sendLoading || disable" v-on:click="testDM()">
              <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon>　</span>DMのテスト
            </v-ons-button>
          </div>
        </v-ons-list-item>

      </div> -->

      <!-- <div v-if="!disable && mode === 'create'">
        <v-ons-list-header>リマインド日数</v-ons-list-header>
        <v-ons-list-item>
          <div class="center">
            <v-ons-select v-model="selectedRemind">
              <option v-for="(rd, index) in remindDates" :value="index" :key="'remind-' + index">
                {{ rd.text }}
              </option>
            </v-ons-select>
          </div>
        </v-ons-list-item>
        <v-ons-list-item>
          <div class="center">
            <span style="color: gray; font-size: 0.8em;">
              設定した日数経過時にあなたへリマインドメールを送信します。<br>
              リマインドメール受信後にログインすることでリマインド日が更新されます。<br>
              リマインド日から14日間以内にログインされない場合には、登録した宛先にメッセージが送信されます。<br>
              リマインド日の設定はアカウント単位ですので全てのメッセージに適用されます。
            </span>
          </div>
        </v-ons-list-item>
      </div> -->

      <br>
      <br>
      <div v-if="inData.type === 'email' || (inData.type === 'twitter' && isTwitter)">
        <div v-if="serviceType === 'scheduled'">
          <v-ons-list-header>送信日設定</v-ons-list-header>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <!-- <date-pick @selected="selectedDate" :value="pickedDateCopy" :inline="false" :format="dateFormat" :language="ja" :typeable="false"></date-pick> -->
              <span style="margin-left: 20px;">
                <v-ons-select v-model="dateYear">
                  <option v-for="(year, index) in years" :value="year" :key="index">
                    {{ year }}
                  </option>
                </v-ons-select>　
              </span>年
              <span style="margin-left: 20px;">
                <v-ons-select v-model="dateMonth">
                  <option v-for="(month, index) in months" :value="month" :key="index">
                    {{ month }}
                  </option>
                </v-ons-select>　
              </span>月
              <span style="margin-left: 20px;">
                <v-ons-select v-model="dateDay">
                  <option v-for="(day, index) in days" :value="day" :key="index">
                    {{ day }}
                  </option>
                </v-ons-select>
              </span>日
            </div>
          </v-ons-list-item>
          <div v-show="!isDateOk">
            <v-ons-list-item modifier="nodivider">
              <div class="center">
                <span style="color: tomato;">
                  <v-ons-icon icon="fa-exclamation-circle"></v-ons-icon>　ライセンス有効期限内に設定してください。
                </span>
              </div>
            </v-ons-list-item>
          </div>
        </div>
        <br>
        <v-ons-list-header>
          <v-ons-button :disabled="disable" modifier="quiet" @click="isAttach = !isAttach">
            <v-ons-icon icon="fa-paperclip"></v-ons-icon>
            <span v-if="inData.type === 'email'">　添付ファイル</span>
            <span v-if="inData.type === 'twitter'">　画像ファイル</span>
          </v-ons-button>
        </v-ons-list-header>
        <div v-show="isAttach">
          <v-ons-list-item modifier="nodivider">
            <div class="left">
              <!-- <input type="file" accept=".pdf,application/pdf" @change="selectPdfFile"> -->
              <span v-if="inData.type === 'email'"><input type="file" @change="selectFile"></span>
              <span v-if="inData.type === 'twitter'"><input type="file" accept="image/png, image/jpeg, image/gif" @change="selectFile"></span>
            </div>
          </v-ons-list-item>
          <div v-for="(file, index) in inData.attachments" :key="index">
            <v-ons-list-item modifier="nodivider">
              <div class="left">
                <span v-if="file.url === ''"><v-ons-progress-circular indeterminate></v-ons-progress-circular></span>
              </div>
              <div class="center">
                <span class="list-item__title" style="font-size: 0.9em;">{{file.name}}</span>
                <span class="list-item__subtitle" style="font-size: 0.8em;">{{file.size | filterFileSize}}</span>
              </div>
              <div class="right">
                <v-ons-button :disabled="disable" @click="deleteAttachment(index)" modifier="quiet"><v-ons-icon icon="fa-times-circle"></v-ons-icon></v-ons-button>
              </div>
            </v-ons-list-item>
          </div>
        </div>

        <div v-if="inData.type === 'email'">
          <v-ons-list-header>
            <v-ons-button :disabled="disable" modifier="quiet" @click="isMovie = !isMovie">
              <v-ons-icon icon="fa-file-video"></v-ons-icon>　動画ファイル
            </v-ons-button>
          </v-ons-list-header>
          <div v-show="isMovie">
            <div v-if="(inData.type === 'email') && (lic.role === 'premium') && (lic.movie < 3)">
              <v-ons-list-item modifier="nodivider">
                <div class="center">
                  <input type="file" accept="video/*" @change="selectFileMovie">
                </div>
              </v-ons-list-item>
              <div v-if="inData.movie">
                <v-ons-list-item modifier="nodivider">
                  <div class="left">
                    <span v-if="inData.movie.url === ''"><v-ons-progress-circular indeterminate></v-ons-progress-circular></span>
                  </div>
                  <div class="center">
                    <span class="list-item__title" style="font-size: 0.9em;">{{inData.movie.name}}</span>
                    <span class="list-item__subtitle" style="font-size: 0.8em;">{{inData.movie.size | filterFileSize}}</span>
                  </div>
                  <div class="right">
                    <v-ons-button :disabled="disable" @click="deleteAttachmentMovie()" modifier="quiet"><v-ons-icon icon="fa-times-circle"></v-ons-icon></v-ons-button>
                  </div>
                </v-ons-list-item>
              </div>
            </div>
          </div>
        </div>

        <br>
        <br>
        <br>
        <br>
        <v-ons-button modifier="large" :disabled="sendLoading || disable" v-on:click="createPostExec()">
          <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon>　</span>保存
        </v-ons-button>
        <div v-if="mode === 'edit'">
          <br>
          <br>
          <br>
          <v-ons-button modifier="large" :disabled="sendLoading" v-on:click="deleteMessage()">
            <span v-show="sendLoading"><v-ons-icon icon="fa-spinner"></v-ons-icon>　</span>メッセージを削除する
          </v-ons-button>
        </div>
      </div>

      <!-- iPhoneSEでスクロールで見切れてる部分の描画が消えるのでダミー改行を入れておく。 -->
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
    </v-ons-list>

    <v-ons-dialog :visible.sync="dialogAddAddress">
      <div class="dialogview2">
        <v-ons-button class="closebutton" modifier="quiet" @click="dialogAddAddress = false"><v-ons-icon icon="fa-window-close"></v-ons-icon></v-ons-button>
        <v-ons-card>
          <div class="content">
            <v-ons-list>
              <v-ons-list-header>名前</v-ons-list-header>
              <v-ons-list-item modifier="nodivider">
                <div class="center">
                  <v-ons-input placeholder="送信先の名前を入力" style="width: 100%;" float v-model="toAddress.name"></v-ons-input>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>メールアドレス(Toで指定するアドレス)</v-ons-list-header>
              <v-ons-list-item modifier="nodivider">
                <div class="center">
                  <v-ons-input placeholder="メールアドレスを入力してください" style="width: 100%;" float v-model="toAddress.address"></v-ons-input>
                </div>
              </v-ons-list-item>
              <v-ons-list-item modifier="nodivider">
                <div class="center" style="text-align: center;">
                  <v-ons-button modifier="large" @click="addAddress('to')">追加する</v-ons-button>
                </div>
              </v-ons-list-item>
            </v-ons-list>
          </div>
        </v-ons-card>
      </div>
    </v-ons-dialog>

    <v-ons-dialog :visible.sync="dialogAddBcc">
      <div class="dialogview2">
        <v-ons-button class="closebutton" modifier="quiet" @click="dialogAddBcc = false"><v-ons-icon icon="fa-window-close"></v-ons-icon></v-ons-button>
        <v-ons-card>
          <div class="content">
            <v-ons-list>
              <v-ons-list-header>名前</v-ons-list-header>
              <v-ons-list-item modifier="nodivider">
                <div class="center">
                  <v-ons-input placeholder="送信先の名前を入力" style="width: 100%;" float v-model="bccAddress.name"></v-ons-input>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>メールアドレス(BCCで指定するアドレス)</v-ons-list-header>
              <v-ons-list-item modifier="nodivider">
                <div class="center">
                  <v-ons-input placeholder="メールアドレスを入力してください" style="width: 100%;" float v-model="bccAddress.address"></v-ons-input>
                </div>
              </v-ons-list-item>
              <v-ons-list-item modifier="nodivider">
                <div class="center" style="text-align: center;">
                  <v-ons-button modifier="large" @click="addAddress('bcc')">追加する</v-ons-button>
                </div>
              </v-ons-list-item>
            </v-ons-list>
          </div>
        </v-ons-card>
      </div>
    </v-ons-dialog>

  </v-ons-page>
</template>

<script>
// import firebase from 'firebase'
import common from '../../util/common'
import comCreate from '../../util/com_create'
import comReminder from '../../util/com_reminder'
import comTwitter from '../../util/com_twitter'
// import comFacebook from '../../util/com_facebook'
import comDate from '../../util/com_date'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'MsgCreate',
  mixins: [common, comCreate, comDate, comReminder, comTwitter],
  components: {VueEditor},
  data () {
    return {
      componentName: 'MsgCreate',
      category: 'messages',
      msg: 'メッセージ作成',
      msg1: 'メッセージ編集',

      postTypes: [
        {name: 'Eメール', type: 'email'},
        {name: 'Twitter', type: 'twitter'}
        // {name: 'Facebook', type: 'facebook'}
      ],

      customToolbar: [
        [{ header: [false, 1, 2, 3] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
          { list: 'ordered' },
          { list: 'bullet' }
        ],
        [{ color: [] }, { background: [] }, 'link']
        // ['image', 'clean']
      ],

      isAttach: false,
      isMovie: false,
      toAddress: {name: '', address: ''},
      bccAddress: {name: '', address: ''},
      dialogAddAddress: false,
      dialogAddBcc: false,
      disable: false,
      mode: 'create',
      serviceType: 'messages',
      due: false,
      movie: '',

      inData: {
        id: '',
        type: '',
        postType: '',
        userId: '',
        userName: '',
        fromAddress: '',
        title: '',
        content: '',
        toAddress: [],
        bccAddress: [],
        attachments: [], // {name: '', size: '', url: ''}
        movie: '',
        params: {},
        targetDate: '',
        targetTimeStamp: '',
        isValid: true, // メッセージが有効かどうか。送信してしまったらfalseにする。
        version: 1, // このドキュメント構造のバージョン
        timeStamp: 0
      }
    }
  },

  created () {
    this.getTwitterAuth()
    this.mode = this.$route.params.mode
    this.serviceType = this.$route.params.serviceType
    // if (this.serviceType === 'messages') {
    //   this.getReminder()
    // }

    if (this.mode === 'edit') {
      this.msg = this.msg1
      this.inData = this.$route.params.item
      this.pickedDate = this.inData.targetDate
      this.pickedDateCopy = this.pickedDate
      this.disable = !this.inData.isValid
      if (this.disable) {
        this.$ons.notification.alert('送信済みメッセージですので<br>編集できません。')
      }
      this.due = this.$route.params.due
      if (!this.due) {
        this.$ons.notification.alert('有効期間が終了しました。<br>以降の編集はできません。')
        this.disable = true
      }
    } else { // create
      this.createDocId()
      this.pickedDate = this.getCurrentDate()
      this.pickedDateCopy = this.pickedDate
      this.pickedDate2 = this.pickedDate
    }
    this.setSelectedDate(this.pickedDate)
    for (let i = 0; i < 22; i++) {
      this.years.push(this.dateYear + i)
    }
    for (let i = 1; i < 13; i++) {
      this.months.push(i)
    }
    for (let i = 1; i < 32; i++) {
      this.days.push(i)
    }
  },

  mounted () {
  },

  filters: {
    stringLengthCheck: function (str, len) {
      if (str.length > len) {
        return '文字数オーバー:　' + (str.length - len)
      }
      return '残り文字数: ' + (len - str.length)
    }
  },

  beforeDestroy () {
    if (this.mode === 'create') {
      if ((this.inData.attachments.length > 0) && (this.pressed === false)) {
        console.log('Destroy attachemets')
        this.deleteAllAttachments()
      }
    } else { // edit
      // メッセージ編集で添付ファイルを追加か削除したのに保存せずに戻る際に、DOCにも反映させる。
      if ((this.isEdit) && (this.pressed === false)) {
        this.setNewPost(this.inData)
      }
    }
  },

  computed: {
  },

  watch: {
  },

  methods: {
    goOauth () {
      const item = {link: 'OpenAuth', anim: 'slide'}
      this.goTo(item)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../src/assets/css/miley.css";
</style>



// WEBPACK FOOTER //
// src/components/MsgChildren/MsgCreate.vue